import react from 'react'
import MyNavbar from '../../../components/user/general/mynavbar/MyNavbar';
import Mechanic from './subfolder/mechanic/Mechanic';
import Footer from '../../../components/user/general/footer/Footer';
import Banner from '../../../subscreens/users/Maintain/maintainbanner/Banner';
import RepairServices from '../../../subscreens/users/Maintain/repairservices/RepairServices';
import QualityStandard from '../../../subscreens/users/Maintain/qualitystandard/QualityStandard';
import MechanicFilter from '../../../components/user/maintain/mechanicfilter/MechanicFilter.js';

const Maintain = () => {
    return (
        <>
            <MyNavbar />
            <Banner />
            <MechanicFilter  />
            <RepairServices />
            {/* <QualityStandard /> */}
            <Footer />
        </>
    );
}

export default Maintain;